export const WILDCARD = "*";
//# sourceMappingURL=constant.js.map
